module.exports = __webpack_public_path__ + "static/media/PDF_100.b2fa67ce.pdf";